import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { NavLink as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, List, ListItemText } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import Iconify from '../iconify';

NavSection.propTypes = {
  allowedNavConfigs: PropTypes.array,
};

export default function NavSection({ allowedNavConfigs = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {allowedNavConfigs.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, subList } = item;
  const [isSubListOpen, setIsSubListOpen] = useState(false);

  return (
    <Box>
      {path !== "/dashboard/diocese" ? (
        <StyledNavItem
          component={RouterLink}
          to={path}
          sx={{
            '&.active': {
              color: 'text.primary',
              bgcolor: 'action.selected',
              fontWeight: 'fontWeightBold',
            },
          }}
          onClick={() => setIsSubListOpen(false)}
        >
          {icon && <StyledNavItemIcon> <Iconify icon={icon} /></StyledNavItemIcon>}
          <ListItemText disableTypography primary={title} />
          {info && info}
        </StyledNavItem>
      ) : (
        <StyledNavItem
          sx={{
            '&.active': {
              color: 'text.primary',
              bgcolor: 'action.selected',
              fontWeight: 'fontWeightBold',
            },
          }}
          onClick={() => setIsSubListOpen(!isSubListOpen)}
        >
          {icon && <StyledNavItemIcon> <Iconify icon={icon} /></StyledNavItemIcon>}
          <ListItemText disableTypography primary={title} />
          {info && info}
          {isSubListOpen && (
            <ArrowDropUpIcon sx={{ mr: 1 }} />

          )}
          {!isSubListOpen && (
            <ArrowDropDownIcon sx={{ mr: 1 }} />
          )}
        </StyledNavItem>
      )}
      {subList && isSubListOpen && (
        <Box
          sx={{
            bgcolor: (theme) => (theme.palette.mode === 'light' ? '#cee8e9' : ''),
            backgroundImage: (theme) =>
              `linear-gradient(135deg, ${alpha(theme.palette.primary.darker, 0)} 0%, ${alpha(
                theme.palette.primary.darker,
                0.24
              )} 100%)`,
            boxShadow: 'inset 4px 4px 8px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            transition: 'height 0.3s ease',
            height: isSubListOpen ? 'auto' : 0,
          }}>
          {subList.map((subItem) => (
            <StyledNavItem
              component={RouterLink}
              to={subItem.path}
              sx={{
                display: subItem.canView ? '' : 'none',
                pl: 5,
                pr: 5,
                '&.active': {
                  color: 'text.primary',
                  bgcolor: 'action.selected',
                  fontWeight: 'fontWeightBold',
                },
              }}
              key={subItem.path}
            >
              {subItem.icon && <StyledNavItemIcon> <Iconify icon={subItem.icon} /></StyledNavItemIcon>}
              <ListItemText disableTypography primary={subItem.title} />
              {subItem.info && subItem.info}
            </StyledNavItem>
          ))}
        </Box>
      )}
    </Box>
  );
}